import { z } from 'zod';

export const loomContentTypeSchema: z.ZodNativeEnum<{
	readonly Video: 'video';
}> = z.nativeEnum({
	Video: 'video',
} as const);
